import React from 'react';
import { Star, Users, Book, Calendar } from 'lucide-react';
export function SocialProofBar() {
  return <div className="py-4 border-y border-blue-200 bg-[#97B9F1]" data-id="element-219">
      <div className="container mx-auto px-4" data-id="element-220">
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-3 text-xs md:text-sm font-bold text-black" data-id="element-221">
          <div className="flex items-center gap-2" data-id="element-222">
            <Users size={16} className="text-blue-600" data-id="element-223" />
            <span data-id="element-224">+500 personas ya lo usan</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-slate-300 rounded-full" data-id="element-225"></div>
          <div className="flex items-center gap-2" data-id="element-226">
            <Book size={16} className="text-blue-600" data-id="element-227" />
            <span data-id="element-228">3 Tomos listos</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-slate-300 rounded-full" data-id="element-229"></div>
          <div className="flex items-center gap-2" data-id="element-230">
            <Calendar size={16} className="text-blue-600" data-id="element-231" />
            <span data-id="element-232">12 semanas de sistema</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-slate-300 rounded-full" data-id="element-233"></div>
          <div className="flex items-center gap-2" data-id="element-234">
            <div className="flex" data-id="element-235">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-yellow-400 text-yellow-400" data-id="element-236" />)}
            </div>
            <span data-id="element-237">4.9/5</span>
          </div>
        </div>
      </div>
    </div>;
}